var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main div-inline"},[_c('div',{staticStyle:{"font-size":"large"}},[_c('a',{on:{"click":_vm.toGzhManager}},[_vm._v("菜单管理")])])])}
var staticRenderFns = []

export { render, staticRenderFns }